import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'Audit',
    description: 'Use the Reverse-Scroll framework to find 5 local businesses with "ghost town" social media.'
  }, {
    number: '2',
    title: 'Offer',
    description: 'Send the "Anti-Cringe" script to offer 5 free high-quality photos or one short video.'
  }, {
    number: '3',
    title: 'Retain',
    description: 'Once they see the value, use our pricing guide to lock in a monthly maintenance fee.'
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center" data-id="element-121">
            How It Works
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-122">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-brand-teal/30 z-0" data-id="element-123"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-124">
              <div className="flex flex-col items-center text-center" data-id="element-125">
                <div className="w-24 h-24 bg-brand-navy text-brand-teal rounded-full flex items-center justify-center text-4xl font-bold mb-6 shadow-xl border-4 border-brand-cream" data-id="element-126">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-lg text-brand-gray leading-relaxed" data-id="element-128">
                  {step.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}